/* eslint-disable no-unused-vars */
import React,  { useRef } from 'react';
import './transactions.css';
import {DataGrid,GridToolbar} from '@material-ui/data-grid';
import { Stack,Button,Grid,Typography, Box, useMediaQuery, Card } from '@mui/material';
import {useState , useEffect} from "react";
import AlertDialog from '../../../components/alertdialog/AlertDialog'
import {TransacModal} from  './modal/TransacModal'
import ShippingInfoModal from './modal/shippingInfoModal/ShippingInfoModal'
import { formarttoCurrency, translateToArabicNumerals, truncateStringNoSuffix } from "../../../utils/Utils"
import {PrintBox} from './printbox/PrintBox.jsx';
import {StoreCard} from  '../../../components';
import {ArrowBackIos,ArrowForwardIos} from '@mui/icons-material';
import { Payment,CancelOutlined} from '@material-ui/icons';
import i18next from 'i18next';
import Storecad from '../../storecard/Storedcad.jsx';
import ContentTitleBar from '../../../components/contentitlebar/ContentTitleBar';
import { myCld } from '../../../cloudinaryImage'
import CustomTypography from '../../customComponent/CustomTypography.jsx';

import Details from './details/Details.jsx'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.js';

const Transactions = ({user,store,handlegetTransactions,transactions,sales,balance,handlegetStores,handleUpdateManyTransactions,handleUpdateTransaction,handleShowAllTransactions,showAlltransactions,switchText,showprogress,setShowProgress,theme,handleRefund,page,setPage,perPage,setPerPage,t,translateStatus,setMessage,setOpenSnackBar}) => {
  const [pageSize, setPageSize] = useState(100);
  const [pageLabel]=useState(page <= 0 ? 1:page)
  const [stores]=useState(JSON.parse(localStorage.getItem('stores')));
  const [selectedRows,setSelectedRows]=useState([]);
  const [selected_Ids,setSelected_Id]=useState([]);
  const [selectionModel,setSelectionModel]=useState([])
  const [status,setStatus]=useState('Paid');
  const [open,setOpen]=useState(false);
  const [openManytrnxModal,setOpenManyTrxModal]=useState(false);
  const [openShipingInfo,setOpenShipingInfo]=useState(false);
  const [shippingData,setShippingData]=useState();
  const [openModal,setOpenModal]=useState(false);
  const [openCancelModal,setOpenCancelMOdal]=useState(false)
  const [orderid,setOrderId]=useState('');
  const [tranxData,setTranxData]=useState([]);
  const [isStoreTransLoaded,setIsStoreTransLoaded]=useState(false)
  const [waitonCustomer,setWaitOnCustomer]=useState(false)
  const [params,setParams]=useState()
  const isDesktop = useMediaQuery('(min-width:600px)');
  const [showDetails,setShowDetails]=useState(false);
  const [selectedTransaction,setSelectedTransaction]=useState()
 /*  const [page,setPage]=useState(1)
  const [perPage,setPerPage]=useState(100)
 */

    const history=useHistory();
  //const componentRef = useRef();
  const [switchstate, setSwitchState] = React.useState(false);
  function handleSwitchChange (e) {
    switchstate(e.target.checked);
    // Add actions here for when the switch is triggered
  };
  const handleOnpageChange = (num) =>{
    if (num >=0){
      setPage(num)
    handlegetTransactions(num,perPage); 
    }

  }
   const handlePrint = ()=>{
    setOpenModal(true);
    setTranxData(selectedRows);
    
   };

   const handleOpenShipingInfo =(row) =>{
    setShippingData(row)
    setOpenShipingInfo(true)
   }

   const handleCloseShipingInfo =() =>{
    setOpenShipingInfo(false)
   }
   const handleOpenCancelModal = (row) =>{
    setParams(row)
    setOpenCancelMOdal(true)
   }

   const refund =(params)=>{
    console.log(params)
    const amount=parseFloat(params.row.totalPrice)+parseFloat(params.row.shippingFees);
    const memo        =`refund for ${params.row.name}`
    const productid   = params.row.productId
    const ordernumber = params.row.orderNumber
    const uid         = params.row.uid
    handleRefund(uid,amount,productid,ordernumber,memo)
   }
  
     const handleHover=()=>{
       return(
         <div>userDetails</div>
       )
     }
     const handlenavigateProductPage = (product)=>{
     /*  console.log(product)
          localStorage.setItem('product', JSON.stringify(product));   

      //navigate to product page
     history.push(`/edit-product?productId=${product._id}&productName=${product.name}&storeId=${store._id}&storeName=${store.name}`);
 */
 }
 const handleClickOpenUpdateManyModal = () => {
 try{
  setStatus(selectedRows[0].status.title)
  console.log(selectedRows[0])
  const status= selectedRows[0].status.title
   if (status === 'Shipped'){
   setWaitOnCustomer(true)
  }else{
     /*setOrderId(row._id);
    let title = row.status.title; */ 
     
    switch (status) {
      case 'Paid' :
       setStatus('Shipped') 
        break;
        case 'Recieved':
         setStatus('Completed') 
          break;
      default:
       setStatus('Paid') 
        break;
    } 

  status!=="Completed" ? setOpenManyTrxModal(true):setOpenManyTrxModal(false);

  }

  
 }catch(err){
  console.log(err)
 }
 
};
 
 const handleClickOpen = (row) => {
         if (row.status.title === 'Shipped'){
          setWaitOnCustomer(true)
         }else{
            setOrderId(row._id);
           let title = row.status.title;
            
           switch (title) {
             case 'Paid' :
              setStatus('Shipped') 
               break;
               case 'Recieved':
                setStatus('Completed') 
                 break;
             default:
              setStatus('Paid') 
               break;
           }
         title!=="Completed" ? setOpen(true):setOpen(false);
       

         }

         
        
      };
   
    const handleOpenTransacModal =(data)=>{
       setOpenModal(true);
       var arr=[];
           arr.push(data)
       setTranxData(arr);
      
    }
    const handleCloseTransacModal = () =>{ 
      setOpenModal(false);
    }


    const handleClose = (option) => {
      
      setOpen(false);
       if (option === true) {
         if (orderid){
        handleUpdateTransaction(orderid,status,setSelectionModel,page,perPage)}
        //console.log(orderid);
         }
    };

    const handleManyTrnxmodalClose = (option) => {
      
      setOpenManyTrxModal(false);
       if (option === true) {
         if (selected_Ids){
          handleUpdateManyTransactions(status,setSelectionModel,selected_Ids,page,perPage)
        //console.log(orderid);
         }
    };
  }
  const handleCloseCancelModal = (option) => {
      console.log(option)
    setOpenCancelMOdal(false);
     if (option === true && params) {
       refund(params)
  };
}
    const handleCloseWait = (option) => {
      
      setWaitOnCustomer(false);
    
    };
  const Span=({id,onClick,type})=>{ 
    /*@param id is the order id 
     *@param onClick is the click event 
     *@param type is the Button class type Pending ,Approved Declined
     */
    return <Grid container justifyContent='center' alignItems='center'>
              <Grid item>
              <span onClick={onClick} id={"status-span-"+id} className={"transStatusSpan "+type}>{translateStatus(type)}</span>
              </Grid>
          </Grid>
}  

const s3Image = (images) =>{
  try{
   
    var s3img = images[0].url ? images[0].url:''
    return s3img
  }catch(err){
    console.log(err)
  }
}

const handleOnTranClick = (transaction) => {
    setSelectedTransaction(transaction);
  setShowDetails(!showDetails)
   history.push(`/transactions/details/${transaction._id}`)
}
const getCloudinaryPulicId = (url) =>{
  const array = url.split('/');
  const lastsegment = array[array.length-1];

  const pid= lastsegment.substring(0, lastsegment.length - 4)

  return myCld.image(`products/${pid}`).format('auto').quality('auto').addFlag('lossy').toURL()
}
 
  useEffect(() => {  
    console.log(showDetails)

      document.getElementsByName("")

    if (!isStoreTransLoaded){
      handlegetTransactions(page-1,perPage); 
      setShowProgress(true)
  /*     if (stores.length >0){
} */
    }
  return () =>{
    setIsStoreTransLoaded(true)
  }
  },[handlegetStores, handlegetTransactions, isStoreTransLoaded, page, perPage, setIsStoreTransLoaded, setShowProgress, showDetails, stores]);
  const getDateNow =(dateNumber)=>{
    var dateString = new Date(parseInt(dateNumber)*1000);
      var newDate= `${dateString.getFullYear()}-${dateString.getMonth()}-${dateString.getDate()} ${dateString.getHours()}:${dateString.getMinutes()}`
      return newDate
   } 




  const columns = [
   /**/  { field: '_id', headerName: 'Id', width: 210,hide:true,
     renderCell:(params)=>{
        return(
          <div style={{color:'cadetblue',cursor:'pointer'}} onClick={()=>{ handleOpenTransacModal(params.row) }}>
            {`${params.row._id}`}
          </div>
        )
     },
  }, 
    {
      field:'user',
      headerName:t("transactions.customer"),
      flex:1,
      hide:false,
        renderCell:(params)=>{
          return(
            <div style={{fontSize:'0.7rem',padding:'0px 2px'}} onClick={()=>{handleOpenShipingInfo(params.row)}}>
                {`${params.row.customer.firstname}`} 
            </div>
        )},
    },
    {
      field: 'name',
      headerName: t("transactions.product"),
      flex: 1,
      renderCell:(params)=>{
        return(
          <div  onClick={()=>{handlenavigateProductPage(params.row)}} style={{cursor:'pointer'}}>
          <img onClick={()=>{handlenavigateProductPage(params.row)}} className="productListImg" src={ process.env.REACT_APP_WEB_IMAGE_LOCATION === 's3' ?s3Image(params.row.s3Image) : getCloudinaryPulicId(params.row.productImageUrl)} alt=""/>
           {/* <span style={{fontSize:'0.8rem'}}>{params.row.name}</span> */}
          </div>
        )
      }

      
    },
    
   /*  {
      field:'storeId',
      headerName:"Store Id",
      width:210,
      editable:true
    }, */
    {
      field:'orderNumber',
      headerName: t("transactions.ordernumber"),
      flex:0.5,
      hide:true,
      renderCell:(params)=>{
        return(
          <>
           <span style={{fontSize:'0.7rem'}}>{params.row.orderNumber}</span>
          </>
        )
      }
    },
    {
      field:'quantity',
      headerName: t("transactions.quantity"),
      flex:0.6,
      renderCell:(params)=>{
        return(
          <>
           <span style={{fontSize:'0.8rem'}}>  {`${i18next.language==='ar' ? translateToArabicNumerals(params.row.quantity) :params.row.quantity}`}{}</span>
          </>
        )
      }
    },
   
    {
      field:'color',
      headerName:t("form.product.colorspecification.label"),
      flex:0.7,
      hide:false,
      renderCell:(params)=>{
        return(
          <>
           <span style={{fontSize:'0.8rem'}}>{params.row.color}</span>
          </>
        )
      }
    },
    {
      field:'size',
      headerName:t("form.product.sizespecification.label"),
      flex:0.7,
      hide:false,
      renderCell:(params)=>{
        return(
          <>
           <span style={{fontSize:'0.8rem'}}>{params.row.size}</span>
          </>
        )
      }

    },
    {
      field:'priceEach',
      headerName: t("form.product.price.label"),
      flex:1,hide:true,
      renderCell:(params)=>{
        return(
          <>
           <span style={{fontSize:'0.8rem'}}>{`${formarttoCurrency(params.row.priceEach,'π')}`}</span>
          </>
        )
      }

    },
    {
      field:'totalPrice',
      headerName: t("transactions.totalprice"),
      flex:1,
      hide:true,
      renderCell:(params)=>{
        return(
          <>
           <span style={{fontSize:'0.8rem'}}>{`${formarttoCurrency(params.row.totalPrice,'π')}`}</span>
          </>
        )
      }
    },
    {
      field: 'shippingFees',
      headerName: t("form.product.shipping.label"),
      flex:1,
      hide:true,
      renderCell:(params)=>{
        return(
          <>
           <span  style={{fontSize:'0.8rem'}}>{`${formarttoCurrency(params.row.shippingFees,'π')}`}</span>
          </>
        )
      }
    },
  /*   {
      field: 'fullname',
      headerName: 'Full Name',
      width: 220,
      editable: true,
      renderCell:(params)=>{
         return(
          <div>{`${params.row.firstname} ${params.row.lastname}`}</div>
         )
      }
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 220,
      editable: true,
    }, */
    {
      field:"status",
      headerName:t("transactions.status"),
      flex:0.8,
      renderCell:(params)=>{
        return(
               <div> <Span id={params.row._id} onClick={()=>{/* handleClickOpen(params.row) */}} type={`${params.row.status.title}`}></Span>
               
               </div>
             )
      }
    },
    {
      field:'date',
      headerName:t("order.date"),
      flex:1,
      hide:true,
   /*    flex:1 */
      renderCell:(params)=>{
        return(
            <div style={{fontSize:'0.6rem'}}>
               {new Date(params.row.dateCreated).toLocaleString()}
            </div>
        )
      }
    },
    {
      field:"action",
      headerName:t("transactions.action"),
      flex:0.6,
      renderCell: (params)=>{
          return(
             <>{params.row.status.title === 'Paid'?
              <CancelOutlined  color='error' onClick={()=>{handleOpenCancelModal(params)}} /> :''
                 }
          
             </>
          )
      }
  }, 
    /* {
        field:"action",
        headerName:"Action",
        width:140,
        renderCell: (params)=>{
            return(
               <>
                <Edit  className="userlistDelete storeListIcons" />

            
                <DeleteOutline className="userlistDelete" onClick={() => {}}/>
               </>
            )
        }
    } */
  ];

  return (
     <Box sx={{ height: 'auto',overflow:'scroll', width: '100%'}}>
    
      
        <Grid container  sx={{paddingLeft:{xs:'16px',sm:'16px',md:1,lg:35},paddingRight:{xs:'16px',sm:'16px',md:1,lg:35}}} xs={12} sm={12} md={12} lg={12} >
      
      {/* <Button onClick={()=>{
          var datenow= new Date()
        var futureDate = new Date(datenow.setMonth(datenow.getMonth()+1))
        console.log(futureDate.toISOString())
      }}>future Date</Button> */}
     {/*  { showprogress ? <CircularProgress className='circularProgress' variant='indeterminate' color ='primary' size={25} />:''} */}

        <TransacModal openModal={openModal} handleCloseTransacModal={handleCloseTransacModal} tranxData={tranxData} />
    
    {
      shippingData ?  <ShippingInfoModal open={openShipingInfo} shippingData={shippingData} handleOpen={handleOpenShipingInfo} title={t("dialog.shippinginfo.title")} handleClose={handleCloseShipingInfo} data={shippingData} showprogress={showprogress} />  :''
    }
     
     <AlertDialog open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} title={t("dialog.updateonetransaction.title")} textContent={t("dialog.updateonetransaction.message",{status:translateStatus(status)})}  /* Icon={Edit} */ positiveButtonText={t("dialog.button.yes")} negativeButtonText={t("dialog.button.cancel")}/>   
     
     <AlertDialog open={openCancelModal} handleClickOpen={handleOpenCancelModal} handleClose={handleCloseCancelModal} title={t("dialog.cancelorder.title")} textContent={t("dialog.cancelorder.message")}  /* Icon={Edit} */ positiveButtonText={t("dialog.button.yes")} negativeButtonText={t("dialog.button.no")}/>   

     <AlertDialog open={openManytrnxModal} handleClickOpen={handleClickOpen} handleClose={handleManyTrnxmodalClose} title={t("dialog.updatetransactions.title")} textContent={t("dialog.updatetransactions.message",{status:translateStatus(status)})}  /* Icon={Edit} */ positiveButtonText={t("dialog.button.yes")} negativeButtonText={t("dialog.button.cancel")}/> 
 
     {
      waitonCustomer ? <AlertDialog open={waitonCustomer}  handleClose={handleCloseWait} title="" textContent={t("dialog.waitcustomer.message")}  /* Icon={Edit} */  negativeButtonText={t("dialog.button.ok")}/> :''
     }
      
      <Grid item xs={12}>
             {
              store ? <Grid container justifyContent='space-between' spacing={2}>
              <Grid item xs={12} >
           
     
             <Storecad  store={store} balance={balance}theme={theme} t={t}/>
     
              </Grid>
              <Grid item xs={12}   marginTop={{sm:1,lg:10}}>
          
          
           <ContentTitleBar store={store} pagetitle={t("transactions.title")} buttons={ store.status==='Verified' ? [{title:t("form.addnew"),link:`/new-product/${store._id}?`},{title:t("form.product.title_prural"),link:`/product-list?storeId=${store._Id}&storeName=${store.name}`}]:[]} t={t}/>  
         
           </Grid>
             </Grid>:''
             }
       </Grid>
   
  
      <Grid item xs ={12} >
        <Grid container justifyContent='flex-start' spacing={1} >
            <Grid item >
       { selectedRows.length >0?  <Button variant='outlined' color='Paid' className='client-action-Button' onClick={()=>{handleClickOpenUpdateManyModal()}}>{t("form.update")}</Button>
            :''}
            </Grid>
      </Grid>

         
          {/*   <Grid item>
            <Button variant='outlined' color='Completed' className='client-action-Button'  onClick={()=>{handleClickOpenUpdateManyModal("Completed")}}>Completed</Button>
            </Grid>
            <Grid item>
               
            </Grid>
            <Grid item>
<Button variant='outlined' color='Shipped' className='client-action-Button'  onClick={()=>{handleClickOpenUpdateManyModal('Shipped');}}>Shipped</Button>
            </Grid>
            <Grid item>
  <Button variant='outlined' color='primary'  className='client-action-Button'  onClick={()=>{handleUpdateManyTransactions("Declined",setSelectionModel,selected_Ids)}}>Decline</Button>
            </Grid> */}
          
      <div className="actionButtonsWrapper">

    
     


  
   
  {/*  <div>
      {text}
      <Switch
        checked={switchstate}
        onChange={handleSwitchChange}
        color="primary"
      />
    </div> 
   
       */}
     </div>    

      <Grid item xs={12}  /* style={{ display: 'flex', height: 'auto',minHeight:'50vh',width:'100%',border:'0px solid'}} */>
        <Grid container justifyContent='space-between' sx={{padding:{sm:0,lg:1},backgroundColor:'#fff',paddingLeft:{xs:'16px',sm:'16px',md:1,lg:5},paddingRight:{xs:'16px',sm:'16px',md:1,lg:5}}}>
        <Box
      sx={{  
        height: '70vh',  
        overFlow:'scroll',
        // Set fixed or responsive width for DataGrid  
        width: "100%", // 90% of the parent container width  
        //maxWidth: 600, // Maximum width of 600px  
        margin: "auto", // Center horizontally  
      }}  
    >  
         {!isDesktop ? 
         <Grid container justifyContent='space-between' alignItems='center'  >
              <Grid item >
                
                 { showDetails ?
                    <Grid container>
                     { selectedTransaction ? <Details  userid={user._id} user={user}  store={store} order={selectedTransaction} myOrders={transactions} setMyOrders={[]} setShowDetails={setShowDetails} showDetails={showDetails} handleOpenShipingInfo={handleOpenShipingInfo} waitonCustomer={waitonCustomer} setWaitOnCustomer={setWaitOnCustomer} //onReviewClick={handleonReviewClick} //onStatusUpdate={onStatusUpdate}
                       setMessage={setMessage} setOpenSnackBar={setOpenSnackBar} /* rateStore={rateStore} rateProduct={rateProduct} updateAppcredits={updateAppcredits}  setisOrdersSorted={setisOrdersSorted} handlerequestRefund={handlerequestRefund}*/ t={t} translateStatus={translateStatus}/> :''}
                    </Grid>:<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: '70vh' ,width:'100%',overflow:'scroll'}}>
                     <Grid container justifyContent={'space-between'} height > {
                      transactions.length >0 ? <>
                         {
                          transactions.map((transaction,index)=>{
                            return(
                             <Grid key={`pm-pro-${index}`}  item xs={12} marginBottom={1}>
                              <Card className='pm-product-card' elevation={0}>
                               <Grid container justifyContent='space-between' alignItems='flex-start' onClick={()=>{/*handleOnTranClick(transaction) */}}> 
                               <Grid item xs={1}>
                                  <img onClick={()=>{handleOnTranClick(transaction)}}className="productListImg" src={process.env.REACT_APP_WEB_IMAGE_LOCATION === 's3' ?s3Image(transaction.s3Image) : getCloudinaryPulicId(transaction.productImageUrl)} alt=""/>
                                  </Grid>
                                <Grid item xs={2.8}>
                                <CustomTypography variant='caption'  onClick={()=>{handleOnTranClick(transaction)}}>
                                {`${truncateStringNoSuffix(transaction.name,10)}`}  </CustomTypography>
                            {/*  <CustomTypography variant='caption'  onClick={()=>{handleOpenShipingInfo(transaction)}}>
                       {`${truncateStringNoSuffix(transaction.customer.firstname,6)}`}  </CustomTypography> */}
                          
                                </Grid>
                                
                                 
                              
                                 {/*  <Grid item xs={1}>
                                <CustomTypography>  {transaction.orderNumber}</CustomTypography>
                                  </Grid> */}
                                  <Grid item xs={1}>
                                  <CustomTypography variant='caption'>  {`${i18next.language==='ar' ? translateToArabicNumerals(transaction.quantity) :transaction.quantity}`}</CustomTypography>
                                  </Grid>
                                  
                                  <Grid item xs={1.5}>
                                  <CustomTypography variant='caption'>{transaction.color}</CustomTypography>
                                  </Grid>
                         {/* <Grid item  xs={1}>
                             <CustomTypography>
                             {formarttoCurrency(transaction.priceEach,'π')}
                             </CustomTypography>
                          </Grid> */}
                              <Grid item xs={1.5}>
                              <CustomTypography>
                              {`π${transaction.totalPrice}`}
                              </CustomTypography>
                          </Grid>
                          <Grid item xs={1}>
                           {transaction.status.title === 'Paid'?
                         <CancelOutlined  color='error' onClick={()=>{handleOpenCancelModal(params)}} /> :''
                             }
          
            
                          </Grid>
                         <Grid item xs={2.5} >
                          <Span id={transaction._id} onClick={()=>{/* handleClickOpen(transaction) */}} type={`${transaction.status.title}`}></Span>
               
                            
                          </Grid>

                            
         
                                  <Grid item >
                                  </Grid>
                                                 
         
                             </Grid>
                             </Card>
                             </Grid>)
                          })
                         }
                      
                      </>:''
         
                     
                    } </Grid>

                    </Box>
                 }
              </Grid>

              
         </Grid> :
          <DataGrid 
          rows={transactions} 
          getRowId={(row) => row._id}
           columns={columns}
           pageSize={pageSize}
           onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
           rowsPerPageOptions={[100]}
           pagination
           paginationMode='server'
          checkboxSelection={true}
          disableSelectionOnClick
          density='compact'
          onPageChange={()=>{handleOnpageChange(page+1)}}
          onSelectionModelChange={(newSelection) => {
             setSelectionModel(newSelection)
             setSelected_Id(newSelection);
             console.log(newSelection);
            const selectedIDs = new Set(newSelection);
            const selectedData=transactions.filter((trans)=>
               selectedIDs.has(trans._id)
            );
            console.log(selectedData)
           setSelectedRows(selectedData);
           }}
           selectionModel={selectionModel}
          components={{
          Toolbar:GridToolbar,

          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              No transactions recorded
            </Stack>
          ),
          NoResultsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              Local filter returns no result
            </Stack>
          )
        }}
      />}



      </Box>
        </Grid>
    </Grid>
    <Grid container justifyContent='space-between' >
             <Grid item xs={4}>
              {selectedRows.length > 0 ?<Grid container justifyContent={'space-between'} paddingTop={2} paddingLeft={1}>
                <Grid item xs={8}>
                 <PrintBox style={{display:'none'}} tranxData={selectedRows} t={t}/> 
                {/*    <div style={{marginBottom:'10%',top:10,border:'0px solid',overflow:'scroll'}}>
  </div> */}
                </Grid>
                <Grid item  xs={4}>
                <Button variant='outlined' className='client-action-Button' color='Paid'  onClick={()=>{handleClickOpenUpdateManyModal()}}>{t("form.update")}</Button>
           
                </Grid>
              </Grid> :''}
             
           {/* <Button color='Paid' className="client-action-Button" onClick={()=>{
       setOpenModal(true);
       setTranxData(selectedRows);
       }}>Print List</Button> */}
             </Grid>
         {  transactions.length >=100  ?<Grid item  xs={8} >
             <Grid container justifyContent='flex-end' padding={2} >
              <Grid item >
              <Typography variant='body1' color={'GrayText'}> {`${(page*perPage)-(perPage-1)} - ${(page*perPage)}`}</Typography>

              </Grid>
              <Grid item  xs={4} marginRight={1}>
                <Grid container justifyContent='space-between'>
        <Grid item xs={4}onClick={()=>{handleOnpageChange(page-1);/* console.log(1) */}}>
      <Button variant='text' color='Paid' className='client-action-Button' >
     <ArrowBackIos color='textGrey' style={{ transform:'scale(0.8)'}}/>
    </Button>
    </Grid>
    <Grid item xs={4} justifyContent={'center'}>
    <Button variant='text' color='Paid' className='client-action-Button' onClick={()=>{}}>
    <Typography variant='body1' color={'GrayText'}> {page}</Typography>
    </Button>
    </Grid>
    <Grid item xs={4}>
    <Button variant='text' color='Paid' className='client-action-Button' onClick={()=>{handleOnpageChange(page+1)}}>
     <ArrowForwardIos color='textGrey' style={{ transform:'scale(0.8)'}}/>
    </Button>
    </Grid>
                </Grid>
              </Grid>
      </Grid>
      </Grid>:''}
         </Grid>
    
    
    </Grid>
   </Grid>
   </Box>
  )
}

export default Transactions

